import { SELECT_SHEET, FILE_PREVIEW, FILE_PREVIEW_ERROR, FILE_UPLOAD } from '../lib/constants'

export default function dataReducer(state = { selected: 0 }, action) {
    switch (action.type) {
        case SELECT_SHEET:
            return {
                ...state,
                selected: action.selected
            }
        case FILE_PREVIEW:
            return {
                ...state,
                selected: 0,
                preview: true,
                sheetData: action.sheetData,
                uid: action.uid,
                importing: false,
                uploadModalTab: action.uploadModalTab,
                importedSuccessfully: true
            }
        case FILE_PREVIEW_ERROR: {
            return {
                ...state,
                selected: 0,
                sheetData: null,
                uid: ''
            }
        }

        case FILE_UPLOAD: {
            return {
                ...state,
                importing: true,
                isModel: action.isModel,
                importedSuccessfully: undefined,
                uploadModalTab: action.uploadModalTab
            }
        }

        case 'UPDATE_SHEET':
            return {
                ...state,
                updatedSuccessfully: true,
                sheetData: [
                    ...state.sheetData.slice(0, action.sheetIndex),
                    {
                        ...action.sheet
                    },
                    ...state.sheetData.slice(action.sheetIndex + 1)
                ]
            }
        case 'UPDATE_DATABASE_MODELS':
            return {
                ...state,
                models: action.models
            }

        case 'UPDATE_SHEET_ERROR':
            return {
                ...state,
                updatedSuccessfully: false,
                updateErrorMessage: action.updateErrorMessage
            }
        case 'MODAL_DISMISSED':
            return {
                ...state,
                updatedSuccessfully: undefined,
                updateErrorMessage: null,
                importedSuccessfully: undefined,
                importedModel: undefined,
                uploadModalTab: false,
                importErrorMessage: null,
                showModalDatabase: false,
                importedModelError: undefined,
                error: false,
                preview: false,
                saveModelStatus: { status: 0, msg: '' }
            }
        case 'UPDATE_FIELD':
            // find sheet
            const sheet = state.sheetData[action.sheet]

            // find cell
            const cell = sheet.header.find(c => c.name === action.cellName)
            const ic = sheet.header.indexOf(cell)

            return {
                ...state,
                sheetData: [
                    ...state.sheetData.slice(0, action.sheet),
                    {
                        ...sheet,
                        header: [
                            ...sheet.header.slice(0, ic),
                            {
                                ...cell,
                                [action.field]: action.value
                            },
                            ...sheet.header.slice(ic + 1)
                        ]
                    },
                    ...state.sheetData.slice(action.sheet + 1)
                ]
            }
        case 'UPDATE_DATABASE':
            return {
                ...state,
                database: { ...state.database, ...action }
            }

        case 'SHEET_IMPORTING':
            return {
                ...state,
                importing: true,
                importedModel: false,
                importingMessage: action.importingMessage,
                importedSuccessfully: undefined
            }

        case 'SHEET_UPLOADING_MODEL':
            return {
                ...state,
                uploading: true,
                importedModel: false,
                importingMessage: action.importingMessage,
                importedSuccessfully: undefined
            }

        case 'SHEET_IMPORTED':
            return {
                ...state,
                importing: false,
                importedModel: true,
                importedSuccessfully: true
            }

        case 'SHEET_IMPORT_ERROR':
            return {
                ...state,
                importing: false,
                importedSuccessfully: false,
                importErrorMessage: action.errorMessage
            }

        case 'UPLOAD_ERROR':
            return {
                ...state,
                error: true,
                uploading: false,
                importing: false,
                importedSuccessfully: false,
                statusCode: action.statusCode,
                importedModelErrorMsg: action.message
            }

        case 'UPLOAD_MODEL_TAB':
            return {
                ...state,
                sheetData: action.sheetData,
                uid: action.uid,
                importing: false,
                uploadModalTab: action.uploadModalTab
                // importedSuccessfully: true
            }
        case 'SHEET_STARTING_SAVE_MODEL':
            return {
                ...state,
                saveModelStatus: { status: -1, msg: 'Loading...' }
            }
        case 'SHEET_SAVE_MODEL':
            return {
                ...state,
                saveModelStatus: { status: 200, msg: 'Save Successful' },
                models: [...state.models, action.model],
            }
        case 'SHEET_SAVE_MODEL_ERROR':
            return {
                ...state,
                saveModelStatus: action.error
            }
        case 'REMOVE_MODEL_START':
            return {
                ...state,
                removeModelStatus: { status: -1, msg: 'Loading...' }
            }
        case 'REMOVE_MODEL_OK':
            return {
                ...state,
                removeModelStatus: { status: 200, msg: action.msg },
                models: action.models
            }
        case 'REMOVE_MODEL_ERROR':
            return {
                ...state,
                removeModelStatus: { status: 500, msg: action.msg }
                // models: []
            }

        case 'GET_PERSPECTIVES':
            return {
                ...state,
                perspectives: action.perspectives
            }

        case 'MODEL_GET_ALL':
            return {
                ...state,
                removeModelStatus: undefined,
                models: action.models,
                historyModels: action.historyModels,
                loadingModels: false
            }

        case 'MODEL_GET_ALL_ERROR':
            return {
                ...state,
                removeModelStatus: undefined,
                models: [],
                error: action.error,
                loadingModels: false
            }

        case 'MODEL_GET_STARTING':
            return {
                ...state,
                loadingModels: true
            }

        case 'GET_DATABASE':
            return {
                ...state,
                // sheetData: action.sheetData,
                headers: action.headers,
                database: action.database,
                dateReference: action.dateReference,
                showModalDatabase: true
            }

        case 'FILE_UPLOAD_MODEL':
            return {
                ...state,
                importing: true,
                importedModel: false
            }
        case 'SHEET_IMPORTED_MODEL':
            return {
                ...state,
                importing: false,
                uploading: false,
                importedModel: true,
                importedModelError: false,
                importingMessage: ''
                // importedSuccessfully: true
            }
        case 'SHEET_IMPORT_MODEL_ERROR':
            return {
                ...state,
                uploading: false,
                importing: false,
                importedModel: false,
                importedModelError: true,
                importedModelErrorMsg: action.errorMessage,
                importErrorMessage: action.errorMessage
            }
        default:
            return state
    }
}
